import React, { Children, useContext} from 'react'
import Navbar from './Components/Navbar/Navbar'
import {  createBrowserRouter, useNavigate } from 'react-router-dom'
import {RouterProvider }from 'react-router-dom';
import Layout from './Components/Layout/Layout'
import Register from './Components/Register/Register'
import Home from './Components/Home/Home'
import Login from './Components/Login/Login'
import Brands from './Components/Brands/Brands'
import Cart from './Components/Cart/Cart'
import Categories from './Components/Categories/Categories'
import Notfound from './Components/Notfound/Notfound';
import Products from './Components/Products/Products';
import ForgetPassword from './Components/ForgetPassword/ForgetPassword';
import Resetcode from './Components/ResetCode/Resetcode';
import Resetpassword from './Components/Resetpassword/Resetpassword';
import { useState } from 'react';
import Changepassword from './Components/Changepassword/Changepassword';
import Changeprofile from './Components/Changeprofile/Changeprofile';
import { ToastContainer } from 'react-toastify';
import ProductDetails from './Components/ProductDetails/ProductDetails';
import CartContextProvider from './Components/Contexts/CartContext';
import Swal from 'sweetalert2';
import PaymentCash from './Components/PaymentMethods/PaymentCash';
import UserOrders from './Components/UserOrders/UserOrders';
import PaymentCredit from './Components/PaymentMethods/PaymentCredit';
import ProtectedRouter from './Components/ProtectedRoute/ProtectedRouter';

export default function App() {
 
  
  const [token, settoken] = useState(null);
 
  function getToken() {
   
  let Token= localStorage.getItem('token');
  settoken(Token);
 
  }
  function logOut() {
    
    localStorage.removeItem('token');
    localStorage.removeItem('userName');
    localStorage.removeItem('cartNum');

      settoken(null);
      
  
    
  }
  const routes=createBrowserRouter([{

    path:'/' ,element:<Layout token={token} logOut={logOut}/>,children:[{
   path:'' ,element:<Home/>},
  { path:'home' ,element:<ProtectedRouter><Home/></ProtectedRouter>},
   {path:'register' ,element:<Register/>},
   {path:'login' ,element:<Login getToken={getToken}/>},
   {path:'brands' ,element:<ProtectedRouter><Brands/></ProtectedRouter>},
   {path:'products' ,element:<ProtectedRouter><Products/></ProtectedRouter>},
   {path:'cart' ,element:<ProtectedRouter><Cart/></ProtectedRouter>},
   {path:'categories' ,element:<ProtectedRouter><Categories/></ProtectedRouter>},
   {path:'forgetPassword', element:<ForgetPassword/>},
   {path:'Resetcode', element:<Resetcode/>},
   {path:'Resetpassword', element:<Resetpassword/>},
   {path:'Changepassword', element:<ProtectedRouter><Changepassword/></ProtectedRouter>},
   {path:'PaymentCash', element:<ProtectedRouter><PaymentCash/></ProtectedRouter>},
   {path:'PaymentCredit', element:<ProtectedRouter><PaymentCredit/></ProtectedRouter>},
   {path:'allorders', element:<ProtectedRouter><UserOrders/></ProtectedRouter>},
   {path:'ProductDetails/:id', element:<ProtectedRouter><ProductDetails/></ProtectedRouter>},
   {path:'Changeprofile', element:<ProtectedRouter><Changeprofile logOut={logOut}/></ProtectedRouter>},
   {path:'*' ,element:<Notfound/>}

 
    ]
    }
  
  
  ])
 

  return <>
  <CartContextProvider>
  <RouterProvider router={routes}/>

  </CartContextProvider>
 <ToastContainer position="top-center"
autoClose={5000}
hideProgressBar
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="colored"/>
  
  </>
  
}
